export const COPILOT_THREAD_ID = 'copilot-thread-id';
export const DRAFT_CHAT_MESSAGE = 'draft-chat-message';
export const DRAFT_PROMPT_TEMPLATE_ID = 'draft-prompt-template-id';
export const DRAFT_PROMPT_TEMPLATE_VALUES = 'draft-prompt-template-values';
export const CONNECTED_APPS_SELECTION = 'connected-apps-selection';
export const LAST_CONNECTED_APPS_LIST = 'last-connected-apps-list';